import prepareOptions from '../../prepareOptions';

export default prepareOptions([
  25, 37, 44, 55, 66, 74, 87, 96, 110, 147, 185, 223, 263, 296, 334,
]);
